import React from 'react';
import styled from 'styled-components';

const MobileExperience = () => (
  <>
    <PageHeader>Welcome to nuLogic Mobile</PageHeader>
    <IntroText>
      Your work, simplified for smaller screens. Tap a shortcut to open the feature you need.
    </IntroText>
    <Footer>
      This mobile view is optimized for fast access and quick navigation inside nuLogic.
    </Footer>
  </>
);

export default MobileExperience;

const PageHeader = styled.h1`
  font-size: 32px;
  margin-bottom: 8px;
  line-height: 1.1;
  color: #111827;
`;

const IntroText = styled.p`
  font-size: 16px;
  color: #4b5563;
  line-height: 1.6;
  max-width: 720px;
`;

const Footer = styled.div`
  margin-top: 32px;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
`;
